// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';

class VenueList extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      data:[],
      filtered_data:[],
      search:'',
      loading: true,
      isFetching: this.props.scoreCard.sales_score_card.isFetching,
      selectedLocation: this.props.scoreCard,
      location:this.props.scoreCard.sales_score_card.requested_venue_id,
      coming_from:this.props.coming_from
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getVenueList(this.state.location);
    // fetchEarningGraphDataIfNeeded();
    // fetchStatsCardDataIfNeeded();
    // fetchStatsTableDataIfNeeded();
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getVenueList(location) {
    this.setState({is_fetching: true,loading: true})
    var url = `${getLocationOrigin()}/get_venue_list/get_venue_details_for_cm/?`;
    const options = {...defaultOptions};

    if(this.props.scoreCard.sales_score_card.requested_venue_id){
        console.log('condition..')
        url = url +"location="+location
    }

    this.state.selectedLocation.sales_score_card.isFetching = false
    fetch(url, options)
     .then(checkStatus)
     .then(parseJSON)
     .then(data => this.setState({data:data.result,filtered_data:data.result,loading:false,is_fetching: false}))
     .catch(error => error)
  }

  handleSearch(event){
    const search = event.target.value.toLowerCase()
    var search_list = []

    if(search == ''){
      search_list = this.state.data 
    }
    else {
      search_list = this.state.data.filter(item=>item.name.toLowerCase().includes(search))
    }
    
    this.setState({filtered_data:search_list,search:search})
  }

  render() {

    var header = ['Name','City','Area','Primary Center Manager','Relationship Manager','Active','Sports']
    var columns = ['name','city','address','primary_center_manager','relationship_manager','status','games']

    const StyledContainer = styled.div`
        width: 100%;
        `

    var loc = this.state.selectedLocation.sales_score_card.isFetching

      if(loc){
        var location = this.state.selectedLocation.sales_score_card.requested_venue_id
        this.getVenueList(location)
        this.setState({isFetching:false,location:location})
      }

    return(
      <div>
        {this.state.loading === true ?
          <div style={{height:500}}>
            <div style={{  position: 'absolute',top: '50%',left: '50%',width: '50%',height: '100%'}}> <Spinner size="50" /></div>
          </div>
          :
          <div className='col-md-12' style={{display:'flex',flexDirection:'column',marginBottom:'2%'}}>
            <div className='col-md-12' style={{display:'flex',justifyContent:'flex-end',float:'right'}}>
              <div className='badge badge-success' style={{background:'#115691',fontSize:'14px',coloe:'white',padding:'5px 10px',margin:'1% 0%'}}> Search - 
                <input name='search' value={this.state.value} onChange={this.handleSearch} style={{color:'black',fontWeight:'500',margin:'0% 1%'}}/> 
              </div>
            </div>
            {this.state.coming_from == 'workbench' ?
              <div className='col-md-12' style={{overflowX:'auto'}}>
                <MaterialList 
                  title='List of Venues'
                  header={header}
                  columns={columns}
                  data={this.state.filtered_data}
                  link = {'/fixtureInfo/'}
                />
              </div>
            :
            <div className='col-md-12' style={{overflowX:'auto'}}>
                <MaterialList 
                  title='List of Venues'
                  header={header}
                  columns={columns}
                  data={this.state.filtered_data}
                  link = {'/venue/'}
                />
            </div>
          }
          </div>
        }
      </div>
    );
  }
}

export default VenueList;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/venueList/VenueList.js